import type { QueryFunctionContext } from '@tanstack/react-query';
import { TeamsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { teamsKeys } from './teamsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof teamsKeys.slugAvailability>>;

export const createFetchTeamSlugAvailabilityQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, slug }], signal }: TParams) =>
    call(() => cancelOnSignal(TeamsService.isSlugAvailable({ oid: organizationId, slug }), signal));
